'use client'

import { IRedux } from '@/app/[locale]/_store/types'
import { useSelector } from 'react-redux'

/** Gates product API calls until shipper settings are ready. */
export function useSharedProductApisReady(): boolean {
  const shipperId = useSelector(
    (state: IRedux) => state.settings?.data?.shipper_id
  )

  return Boolean(shipperId)
}
